import React from 'react';
import { PageHero } from '../components/PageHero';
import { BidsTenders } from '../components/BidsTenders';
export function BidsPage() {
  return <>
      <PageHero breadcrumb="Bids & Tenders" title="Bids & Tenders" subtitle="Current open opportunities to partner with the African Union Commission across goods, works, and services." data-id="element-285" />
      <BidsTenders data-id="element-286" />
    </>;
}